module.exports = __webpack_public_path__ + "static/media/39_Publicity_Cell.1e4726fd.JPG";